import {
  CASE_FETCH_AI_SETTINGS_OPTIONS_BEGIN,
  CASE_FETCH_AI_SETTINGS_OPTIONS_SUCCESS,
  CASE_FETCH_AI_SETTINGS_OPTIONS_FAILURE,
  CASE_FETCH_AI_SETTINGS_OPTIONS_DISMISS_FEEDBACK,
} from './constants';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';

export const fetchAiSettingsOptions = createPromiseAction(
  CASE_FETCH_AI_SETTINGS_OPTIONS_BEGIN,
  (payload) => {
    return { ...payload };
  },
);

export function dismissFetchAiSettingsOptionsFeedback() {
  return {
    type: CASE_FETCH_AI_SETTINGS_OPTIONS_DISMISS_FEEDBACK,
  };
}

export function* doFetchAiSettingsOptions(action) {
  const { caseId } = action.payload;

  let res = yield call(api.get, `/cases/${caseId}/ai-settings-options`);

  if (res && res.error) {
    yield put({
      type: CASE_FETCH_AI_SETTINGS_OPTIONS_FAILURE,
      feedback: {
        message: 'feedback.fetchAiSettingsOptionsFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_FETCH_AI_SETTINGS_OPTIONS_SUCCESS,
    data: res,
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchFetchAiSettingsOptions() {
  yield takeLatest(fetchAiSettingsOptions, withCurrentCaseId(doFetchAiSettingsOptions));
}

export function useFetchAiSettingsOptions() {
  const dispatch = useDispatch();

  const { aiSettingsOptions, fetchAiSettingsOptionsPending, fetchAiSettingsOptionsFeedback } =
    useSelector(
      (state) => ({
        aiSettingsOptions: state.case.aiSettingsOptions,
        fetchAiSettingsOptionsPending: state.case.fetchAiSettingsOptionsPending,
        fetchAiSettingsOptionsFeedback: state.case.fetchAiSettingsOptionsFeedback,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(fetchAiSettingsOptions(...args));
    },
    [dispatch],
  );

  const boundDismissFeedback = useCallback(() => {
    return dispatch(dismissFetchAiSettingsOptionsFeedback());
  }, [dispatch]);

  return {
    aiSettingsOptions,
    fetchAiSettingsOptions: boundAction,
    fetchAiSettingsOptionsPending,
    fetchAiSettingsOptionsFeedback,
    dismissFetchAiSettingsOptionsFeedback: boundDismissFeedback,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_FETCH_AI_SETTINGS_OPTIONS_BEGIN + '.TRIGGER':
      return {
        ...state,
        fetchAiSettingsOptionsPending: true,
        fetchAiSettingsOptionsFeedback: null,
      };
    case CASE_FETCH_AI_SETTINGS_OPTIONS_SUCCESS:
      return {
        ...state,
        fetchAiSettingsOptionsPending: false,
        aiSettingsOptions: action.data,
      };
    case CASE_FETCH_AI_SETTINGS_OPTIONS_FAILURE:
      return {
        ...state,
        fetchAiSettingsOptionsPending: false,
        fetchAiSettingsOptionsFeedback: action.feedback,
      };
    case CASE_FETCH_AI_SETTINGS_OPTIONS_DISMISS_FEEDBACK:
      return {
        ...state,
        fetchAiSettingsOptionsFeedback: null,
      };
    default:
      return state;
  }
}
